import React from 'react'
import MaterialSymbol from '../material-symbol'

const Campaign = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="campaign" {...props} />
))

Campaign.displayName = 'Campaign'

export default Campaign
